// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React from 'react';

import a from '../../images/comesa-blue-png.png';
import b from '../../images/chaminuka.jpg';
import c from '../../images/IC-Logo.png';
import d from '../../images/taj.png';
import e from '../../images/protea-logo_rev.png';
import f from '../../images/sa-high-c.png';

export const Clients = () => {

  const clients = [
    {
      id: 1,
      name: 'COMESA',
      logo: a,
    },
    {
      id: 2,
      name: 'Chaminuka Lodge',
      logo: b,
    },
    {
      id: 3,
      name: 'Intercontinental Hotel',
      logo: c,
    },
    {
      id: 4,
      name: 'Taj Pamodzi Hotel',
      logo: d,
    },
    {
      id: 5,
      name: 'Protea Hotels',
      logo: e,
    },
    // {
    //   id: 6,
    //   name: 'Danish Embassy',
    //   logo: '',
    // },
    {
      id: 7,
      name: 'South African High Commission',
      logo: f,
    },
  ];

  return (
    <section className="clients-section-clean position-relative py-5" style={{ background: 'linear-gradient(120deg, #f8fafc 60%, #e3e8ee 100%)', overflow: 'hidden' }}>
      {/* Large, faint purple blob */}
      <div style={{
        position: 'absolute',
        bottom: '-120px',
        right: '-180px',
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, #6f42c1 0%, #fff0 80%)',
        zIndex: 0,
        opacity: 0.13,
        borderRadius: '50%',
        filter: 'blur(2.5px)'
      }} />
      <div className="container position-relative" style={{zIndex: 2}}>
        <h2 className="fw-bold display-5 mb-4 text-center">Our Esteemed Clients</h2>
        <div className="row justify-content-center g-4">
          {clients.map((client) => (
            <div className="col-6 col-md-3 col-lg-2 d-flex align-items-center justify-content-center" key={client.id}>
              <div className="bg-white rounded-4 shadow-sm p-3 w-100 d-flex align-items-center justify-content-center client-logo-card" style={{transition: 'transform 0.18s', cursor: 'pointer'}} onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-6px) scale(1.06)')} onMouseOut={e => (e.currentTarget.style.transform = 'none')}>
                <img src={client.logo} alt={client.name} className="img-fluid" style={{maxHeight: 60, objectFit: 'contain'}} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
